import styled from 'styled-components';

export const Form = styled.form<FormProps>`
	width: ${props => (props.$modal ? '360px' : '100%')};
	max-width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth : '570px')};
	display: flex;
	flex-direction: ${props => (props.$noColumn === true ? 'column' : 'row')};
	column-gap: 48px;
	row-gap: 12px;
	@media (max-width: 600px) {
		width: ${props => (props.$modal ? '300px' : '100%')};
		width: 100%;
		flex-direction: column;
		column-gap: 0;
	}
`;

export const LeftColumn = styled.div`
	width: 50%;
	display: flex;
	flex-direction: column;
	row-gap: 12px;
	@media (max-width: 600px) {
		width: 100%;
	}
`;

export const RightColumn = styled.div`
	width: 50%;
	display: flex;
	flex-direction: column;
	row-gap: 12px;
	@media (max-width: 600px) {
		flex-direction: column;
		width: 100%;
	}
`;

export const ComboContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	column-gap: 12px;
	align-items: flex-start;
`;

export const ButtonContainer = styled.div`
	margin-top: 12px;
	width: 100%;
	display: flex;
	justify-content: flex-end;
	column-gap: 8px;
`;

interface FormProps extends React.FormHTMLAttributes<HTMLButtonElement> {
	$noColumn?: boolean;
	$modal?: boolean;
	$maxWidth?: string;
}
